import React, { Fragment } from "react"
import contains from "underscore/modules/contains"
import reject from "underscore/modules/reject"

import ServiceRow from "../ServiceRow"
import DropDownSorting from "./DropDownSorting"

import style from "./index.module.sass"

// ----------------------------------------------------------------------------

function ServicesSection(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const {
    sectionState,
    onServiceClick,
    sortFunction = null,
    handleSort,
  } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function filterServiceByQuery(service, query) {
    return !query || service.name.toLowerCase().includes(query.toLowerCase())
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // GUARD
  if (!sectionState || !sectionState.services) {
    return <Fragment></Fragment>
  }

  const {
    services,
    categoryId,
    title,
    service_section_part_configs,
    orderingEnabled,
    query,
  } = sectionState

  let availableServices = [...services]

  if (!!sortFunction) {
    availableServices.sort(sortFunction.sortHandler)
  }

  availableServices = availableServices
    .filter(
      (service) =>
        service.published === true && filterServiceByQuery(service, query)
    )
    .map((service) => {
      const disabledPartConfigIds =
        service.excluded_service_section_part_config_ids || []
      const enabledServiceSectionPartConfigs = reject(
        service_section_part_configs,
        (config) => {
          return contains(disabledPartConfigIds, config.id)
        }
      )

      return (
        <ServiceRow
          key={service.id}
          service={service}
          serviceSectionPartConfigs={enabledServiceSectionPartConfigs}
          orderingEnabled={orderingEnabled}
          onShowModal={onServiceClick}
        />
      )
    })

  // -------------------------------------

  return (
    <Fragment>
      <div className={style.headingContainer}>
        <div className={style.copyContainer}>
          <h3 id={categoryId} className={style.title}>
            {title}
          </h3>

          <p className={style.subtitle}>
            {I18n.t("service_ordering.search_results_title_count", {
              count: availableServices?.length || 0,
            })}
          </p>
        </div>
        <DropDownSorting sortFunction={sortFunction} handleSort={handleSort} />
      </div>
      <div className={style.servicesContainer}>
        {availableServices}
        {/* Prevent last line elements to grow without control */}
        {/* Actually the only working work-around to this flex lack */}
        <div className={style.lastCard}></div>
        <div className={style.lastCard}></div>
        <div className={style.lastCard}></div>
      </div>
    </Fragment>
  )
}

export default ServicesSection
